export default "__VITE_ASSET__kYqaV$UI__"